export const setDocumentTitle = (title) => {
  document.title = typeof title === "object" ? title?.props?.children[0] : title;
};
